import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e61aa5b2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-row"
};
const _hoisted_2 = {
  class: "standard pad12"
};
const _hoisted_3 = {
  class: "td"
};
const _hoisted_4 = {
  class: "product"
};
const _hoisted_5 = {
  class: "image-badge-wrapper"
};
const _hoisted_6 = {
  class: "image-wrapper"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "percentage-badge-flag"
};
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = {
  key: 1,
  class: "country-text"
};
const _hoisted_11 = ["id"];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tooltip-description-revenue-share"
}, "Revenue Share", -1));
const _hoisted_13 = {
  class: "info"
};
const _hoisted_14 = {
  class: "name"
};
const _hoisted_15 = {
  class: "asin-sku"
};
const _hoisted_16 = {
  key: 0,
  class: "inactive-tag"
};
const _hoisted_17 = {
  class: "status-chip"
};
const _hoisted_18 = {
  class: "days-chip"
};
const _hoisted_19 = {
  class: "standard pad12",
  style: {
    "background": "#F7FCF9 !important"
  }
};
const _hoisted_20 = {
  class: "sub-cell-unit"
};
const _hoisted_21 = {
  class: "title"
};
const _hoisted_22 = {
  class: "status-wrapper"
};
const _hoisted_23 = {
  key: 0,
  class: "icon"
};
const _hoisted_24 = {
  key: 1,
  class: "icon"
};
const _hoisted_25 = {
  key: 2,
  class: "icon"
};
const _hoisted_26 = {
  key: 3,
  class: "icon"
};
const _hoisted_27 = {
  class: "status-text"
};
const _hoisted_28 = {
  key: 0,
  class: "winner-green"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "winner-green-header"
}, [/*#__PURE__*/_createElementVNode("span", null, "Winner")], -1));
const _hoisted_30 = [_hoisted_29];
const _hoisted_31 = {
  key: 1,
  class: "winner-green"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "winner-green-header"
}, [/*#__PURE__*/_createElementVNode("span", null, "Co-winner")], -1));
const _hoisted_33 = {
  class: "company"
};
const _hoisted_34 = {
  key: 2,
  class: "no-buybox"
};
const _hoisted_35 = {
  key: 3,
  class: "no-buybox"
};
const _hoisted_36 = {
  class: "company"
};
const _hoisted_37 = ["id"];
const _hoisted_38 = ["id"];
const _hoisted_39 = {
  key: 2,
  style: {
    "margin-left": "auto",
    "margin-right": "8px",
    "display": "inline-flex",
    "align-items": "center",
    "white-space": "nowrap"
  },
  class: "no-buybox"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tooltip-description-revenue-share"
}, "% of buybox over 28 days", -1));
const _hoisted_41 = {
  class: "standard-product-search sps-right-fix"
};
const _hoisted_42 = {
  class: "sub-cells"
};
const _hoisted_43 = {
  class: "sub-cell"
};
const _hoisted_44 = {
  class: "title"
};
const _hoisted_45 = {
  style: {
    "text-align": "start",
    "color": "#4D4D4D"
  }
};
const _hoisted_46 = {
  class: "sub-cell"
};
const _hoisted_47 = {
  class: "title"
};
const _hoisted_48 = {
  class: "value-wrapper"
};
const _hoisted_49 = {
  class: "gap-sign"
};
const _hoisted_50 = {
  class: "price-box"
};
const _hoisted_51 = {
  class: "standard-product-search right-aligned show-margin-ccy"
};
const _hoisted_52 = {
  class: "sub-cell-unit"
};
const _hoisted_53 = {
  class: "cell-stack"
};
const _hoisted_54 = {
  class: "no-buybox",
  style: {
    "color": "#4D4D4D"
  }
};
const _hoisted_55 = {
  class: "standard-product-search right-aligned",
  style: {
    "border": "1px solid #F4F4F4 !important",
    "opacity": "0.56 !important",
    "background": "#FFF !important",
    "color": "#4D4D4D !important",
    "font-family": "Figtree",
    "font-size": "14px !important"
  }
};
const _hoisted_56 = {
  class: "sub-cell-unit"
};
const _hoisted_57 = {
  class: "referral-program"
};
const _hoisted_58 = {
  class: "standard fees-col"
};
const _hoisted_59 = {
  class: "sub-cells"
};
const _hoisted_60 = {
  class: "sub-cell"
};
const _hoisted_61 = {
  class: "title"
};
const _hoisted_62 = {
  class: "referral-program"
};
const _hoisted_63 = {
  class: "sub-cell"
};
const _hoisted_64 = {
  class: "title"
};
const _hoisted_65 = {
  class: "referral-program"
};
const _hoisted_66 = {
  class: "fulfilment-program"
};
const _hoisted_67 = {
  class: "sub-cell"
};
const _hoisted_68 = {
  class: "title"
};
const _hoisted_69 = {
  class: "referral-program"
};
const _hoisted_70 = {
  class: "standard-product-search right-aligned",
  style: {
    "border": "1px solid #F4F4F4 !important",
    "opacity": "0.56 !important",
    "background": "#FFF !important",
    "color": "#4D4D4D !important",
    "font-family": "Figtree",
    "font-size": "14px !important"
  }
};
const _hoisted_71 = {
  class: "sub-cell-unit"
};
const _hoisted_72 = {
  class: "referral-program"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_popover = _resolveComponent("b-popover");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_currency_value = _resolveComponent("currency-value");
  return _openBlock(), _createElementBlock("tr", _hoisted_1, [_createElementVNode("td", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
    src: $options.image,
    alt: ""
  }, null, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, [$options.getCountryFlag($props.item?.country_code) ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    class: "country-flag",
    src: $options.getCountryFlag($props.item?.country_code),
    alt: $props.item.country_code
  }, null, 8, _hoisted_9)) : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString($props.item.country_code), 1))]), _createElementVNode("div", {
    id: `tooltip-target-revenue-share-${$options.computedId}`,
    class: "percentage-badge"
  }, _toDisplayString($props.item.revenue_share_sku_marketplace_seller_id_last_28d != null ? ($props.item.revenue_share_sku_marketplace_seller_id_last_28d * 100).toFixed(0) + '%' : '0%'), 9, _hoisted_11)]), _createVNode(_component_b_popover, {
    target: `tooltip-target-revenue-share-${$options.computedId}`,
    triggers: "hover",
    "custom-class": "wrap-with-popover revenue-share-popover"
  }, {
    default: _withCtx(() => [_hoisted_12]),
    _: 1
  }, 8, ["target"]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString($props.item.product_name), 1), _createElementVNode("div", _hoisted_15, _toDisplayString($options.asinSku), 1), ['Inactive', 'Incomplete'].includes($props.item.listing_status) ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString($props.item.listing_status), 1), _createElementVNode("div", _hoisted_18, _toDisplayString($options.formattedDaysOfInventory), 1)])) : _createCommentVNode("", true)])])])]), _createElementVNode("td", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [$props.item.buybox_status === 'WINNER' ? (_openBlock(), _createElementBlock("span", _hoisted_23, [_createVNode(_component_app_icon, {
    icon: "buy-box-winner"
  })])) : $props.item.buybox_status === 'CO_WINNER' ? (_openBlock(), _createElementBlock("span", _hoisted_24, [_createVNode(_component_app_icon, {
    icon: "buy-box-co-winner"
  })])) : $props.item.buybox_status === 'LOOSER' ? (_openBlock(), _createElementBlock("span", _hoisted_25, [_createVNode(_component_app_icon, {
    icon: "buy-box-looser"
  })])) : $props.item.buybox_status === 'NO_BUYBOX' ? (_openBlock(), _createElementBlock("span", _hoisted_26, [_createVNode(_component_app_icon, {
    icon: "buy-box-no-buybox"
  })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_27, [$props.item.buybox_status === 'WINNER' ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30)) : $props.item.buybox_status === 'CO_WINNER' ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_hoisted_32, _createElementVNode("div", _hoisted_33, _toDisplayString($props.item.buybox_seller), 1)])) : $props.item.buybox_status === 'NO_BUYBOX' ? (_openBlock(), _createElementBlock("div", _hoisted_34, " No buybox ")) : $props.item.buybox_status === 'LOOSER' ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_createTextVNode(" Looser "), _createElementVNode("div", _hoisted_36, _toDisplayString($props.item.buybox_seller), 1)])) : _createCommentVNode("", true)])])]), $props.item.buybox_status === 'WINNER' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    id: `${$options.computedId}`,
    style: {
      "margin-left": "auto",
      "margin-right": "8px",
      "display": "inline-flex",
      "align-items": "center",
      "white-space": "nowrap"
    },
    class: "winner-green"
  }, [_createElementVNode("span", null, _toDisplayString($options.revenueShareforProducts), 1)], 8, _hoisted_37)) : _createCommentVNode("", true), $props.item.buybox_status === 'CO_WINNER' ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    id: `${$options.computedId}`,
    style: {
      "margin-left": "auto",
      "margin-right": "8px",
      "display": "inline-flex",
      "align-items": "center",
      "white-space": "nowrap"
    },
    class: "winner-green"
  }, [_createElementVNode("span", null, _toDisplayString($options.revenueShareforProducts), 1)], 8, _hoisted_38)) : _createCommentVNode("", true), $props.item.buybox_status === 'LOOSER' ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("span", null, _toDisplayString($options.revenueShareforProducts), 1)])) : _createCommentVNode("", true), _createVNode(_component_b_popover, {
    target: `${$options.computedId}`,
    triggers: "hover",
    "custom-class": "wrap-with-popover revenue-share-popover"
  }, {
    default: _withCtx(() => [_hoisted_40]),
    _: 1
  }, 8, ["target"])])]), _createElementVNode("td", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("span", _hoisted_45, [$props.item.buybox_status === 'WINNER' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createTextVNode("-")], 64)) : $options.calculateBuyBox !== null ? (_openBlock(), _createBlock(_component_currency_value, {
    key: 1,
    value: $options.calculateBuyBox,
    precision: "2",
    currency: $props.item.currency
  }, null, 8, ["value", "currency"])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createTextVNode("-")], 64))])])]), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [$options.calculateGap ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "margin-box",
    style: _normalizeStyle({
      color: $options.calculateGap.color
    })
  }, [_createElementVNode("span", _hoisted_49, _toDisplayString($options.calculateGap.sign), 1), _createVNode(_component_currency_value, {
    value: $options.calculateGap.abs,
    precision: "2",
    currency: $props.item.currency
  }, null, 8, ["value", "currency"])], 4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_50, [_createVNode(_component_currency_value, {
    value: $props.item.price,
    precision: "2",
    currency: $props.item.currency
  }, null, 8, ["value", "currency"])])])])])])]), _createElementVNode("td", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("span", _hoisted_54, [_createVNode(_component_currency_value, {
    value: $props.item.margin_ccy,
    precision: "2",
    currency: $props.item.currency
  }, null, 8, ["value", "currency"])]), _createElementVNode("div", {
    class: _normalizeClass(["ccy-inline", {
      negative: $options.isNegative($props.item.margin_rate)
    }])
  }, _toDisplayString($options.formatMarginRate($props.item.margin_rate)), 3)])])]), _createElementVNode("td", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createElementVNode("span", _hoisted_57, [_createVNode(_component_currency_value, {
    value: $props.item.tax_est,
    precision: "2",
    currency: $props.item.currency
  }, null, 8, ["value", "currency"])])])]), _createElementVNode("td", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("span", _hoisted_62, [_createVNode(_component_currency_value, {
    value: $props.item.fees_estimate,
    precision: "2",
    currency: $props.item.currency
  }, null, 8, ["value", "currency"])])])]), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_createElementVNode("span", _hoisted_65, [_createVNode(_component_currency_value, {
    value: $props.item.fba_fees,
    precision: "2",
    currency: $props.item.currency
  }, null, 8, ["value", "currency"])]), _createElementVNode("div", _hoisted_66, _toDisplayString($props.item.fulfilmment_program), 1)])]), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createElementVNode("span", _hoisted_69, [_createVNode(_component_currency_value, {
    value: $props.item.prep_fees,
    precision: "2",
    currency: $props.item.currency
  }, null, 8, ["value", "currency"])])])])])]), _createElementVNode("td", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_createElementVNode("span", _hoisted_72, [_createVNode(_component_currency_value, {
    value: $props.item.wholesale_ccy,
    precision: "2",
    currency: $props.item.currency
  }, null, 8, ["value", "currency"])])])])]);
}